'use client';

import { signIn } from 'next-auth/react';
import { StackedMark } from '@/components/brand/StackedMark';

export default function LoginPage() {
  return (
    <main className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background px-6">
      {/* Nocturne atmosphere: aurora wash + fine grid fading toward center */}
      <div aria-hidden className="pointer-events-none absolute inset-0 bg-nocturne" />
      <div aria-hidden className="pointer-events-none absolute inset-0 bg-grid opacity-40" />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 [background:radial-gradient(65%_55%_at_50%_45%,hsl(var(--background))_25%,transparent_100%)]"
      />

      {/* Top-left wordmark */}
      <div className="absolute left-8 top-7 flex items-center gap-2.5 text-foreground">
        <StackedMark size={24} />
        <span className="font-display text-[16px] font-semibold tracking-tight">Stacked</span>
      </div>

      {/* Bottom marginalia */}
      <div className="absolute bottom-7 left-8">
        <p className="eyebrow">Nocturne · 2026</p>
      </div>
      <div className="absolute bottom-7 right-8 flex items-center gap-3">
        <span className="hairline-v h-4" />
        <p className="eyebrow">Plan tomorrow, tonight</p>
      </div>

      <div className="relative w-full max-w-2xl space-y-12">
        <header className="space-y-7 text-center">
          <div
            className="flex animate-rise-in justify-center text-foreground"
            style={{ animationDelay: '60ms' }}
          >
            <StackedMark size={64} className="drop-shadow-[0_0_24px_rgba(245,165,36,0.25)]" />
          </div>
          <div className="animate-rise-in space-y-6" style={{ animationDelay: '140ms' }}>
            <p className="eyebrow">Welcome to the workspace</p>
            <h1 className="hero text-[clamp(4rem,12vw,8.5rem)]">
              Stacked<span className="text-accent">.</span>
            </h1>
            <p className="mx-auto max-w-md text-[15px] leading-relaxed text-muted-foreground">
              Smart scheduling that respects your calendar, your commute, and
              the way you actually work.
            </p>
          </div>
        </header>

        <div
          className="mx-auto max-w-sm animate-rise-in space-y-4"
          style={{ animationDelay: '240ms' }}
        >
          <button
            type="button"
            onClick={() => signIn('google', { callbackUrl: '/' })}
            className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-foreground px-4 py-3.5 text-sm font-semibold text-background transition duration-fast ease-out-quint hover:brightness-110 hover:shadow-glow"
          >
            Continue with Google
            <span
              aria-hidden
              className="transition-transform duration-fast ease-out-quint group-hover:translate-x-0.5"
            >
              →
            </span>
          </button>
          <p className="px-2 text-center text-xs leading-relaxed text-subtle-foreground">
            Stacked reads your Google Calendar to plan tasks around your
            meetings. Your data stays yours.
          </p>
        </div>
      </div>
    </main>
  );
}
